// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb--6SAe3H-oxD","arrow":"arrow--betNbvk-7a"};